var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3871 11.9987L20.4183 3.61749C20.5362 3.47821 20.4371 3.2666 20.2549 3.2666H18.1174C17.9916 3.2666 17.871 3.32285 17.788 3.41928L11.9889 10.3327L6.18977 3.41928C6.10941 3.32285 5.98887 3.2666 5.8603 3.2666H3.7228C3.54066 3.2666 3.44155 3.47821 3.55941 3.61749L10.5907 11.9987L3.55941 20.38C3.53301 20.411 3.51607 20.449 3.51061 20.4894C3.50514 20.5298 3.51138 20.5709 3.52859 20.6078C3.54579 20.6448 3.57323 20.676 3.60766 20.6978C3.64209 20.7196 3.68205 20.7311 3.7228 20.7309H5.8603C5.98619 20.7309 6.10673 20.6746 6.18977 20.5782L11.9889 13.6648L17.788 20.5782C17.8683 20.6746 17.9889 20.7309 18.1174 20.7309H20.2549C20.4371 20.7309 20.5362 20.5193 20.4183 20.38L13.3871 11.9987Z",
    fill: "black",
    fillOpacity: 0.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e3a61132bc3cf22912c8bf0fa2e1b39a.svg";
export { ForwardRef as ReactComponent };